document.addEventListener('DOMContentLoaded', function () {
  initVgReveal();
  initVgTicker();
  initVgGallery();
  initVgVariantPicker();
  initVgFaq();
});

function initVgReveal() {
  var els = document.querySelectorAll('.vg-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('vg-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vg-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initVgTicker() {
  document.querySelectorAll('[data-vg-ticker]').forEach(function (el) {
    var speed = parseFloat(el.getAttribute('data-speed')) || 26;
    el.style.animationDuration = speed + 's';
  });
}

function initVgGallery() {
  document.querySelectorAll('[data-vg-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-vg-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-vg-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-full');
        main.src = url;
        thumbs.forEach(function (t) { t.classList.remove('vg-active'); });
        thumb.classList.add('vg-active');
      });
    });
  });
}

function initVgVariantPicker() {
  document.querySelectorAll('[data-vg-product-form]').forEach(function (form) {
    var variantsData = form.querySelector('[data-vg-variants]');
    if (!variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

    var optionButtons = form.querySelectorAll('[data-vg-option]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-vg-price]');
    var comparePriceEl = form.querySelector('[data-vg-compare-price]');
    var addBtn = form.querySelector('[data-vg-add-btn]');
    var isMaintenance = form.getAttribute('data-vg-maintenance') === 'true';
    var galleryImgs = form.closest('[data-vg-product]') ? form.closest('[data-vg-product]').querySelectorAll('[data-vg-gallery-thumb]') : [];

    function currentSelection() {
      var selected = {};
      form.querySelectorAll('[data-vg-option].vg-active').forEach(function (btn) {
        selected[btn.getAttribute('data-vg-option')] = btn.getAttribute('data-value');
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (k) {
          return v.options[k] === selected[k];
        });
      });
    }

    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function refreshAvailability(optionName, selected) {
      form.querySelectorAll('[data-vg-option="' + optionName + '"]').forEach(function (btn) {
        var testSelection = Object.assign({}, selected);
        testSelection[optionName] = btn.getAttribute('data-value');
        var match = findVariant(testSelection);
        btn.disabled = !match;
      });
    }

    function updateUI() {
      var selected = currentSelection();
      var variant = findVariant(selected);
      Object.keys(selected).forEach(function (optName) { refreshAvailability(optName, selected); });

      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (isMaintenance) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-label-soldout');
        } else {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
        }
      }
      if (variant.featured_image && galleryImgs.length) {
        var mainImg = form.closest('[data-vg-product]').querySelector('[data-vg-gallery-main]');
        if (mainImg) mainImg.src = variant.featured_image;
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var optName = btn.getAttribute('data-vg-option');
        form.querySelectorAll('[data-vg-option="' + optName + '"]').forEach(function (b) { b.classList.remove('vg-active'); });
        btn.classList.add('vg-active');
        updateUI();
      });
    });

    updateUI();
  });
}

function initVgFaq() {
  document.querySelectorAll('.vg-faq-item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        item.closest('.vg-faq-list').querySelectorAll('.vg-faq-item').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });
}
